module.exports = __webpack_public_path__ + "static/media/hack2.32e3039b.jpg";